import React from 'react';
import { BestellungDetails } from '../../types';
import { FormRow } from '../Form/FormRow';
import { FormColumnContent } from '../Form/FormColumnContent';

export const KfzKennzeichenAndSpeditionFormRow: React.FC<{ bestellung: BestellungDetails }> = ({ bestellung }): JSX.Element => {
    return (
        <FormRow>
            <FormColumnContent content={bestellung.kfzKennzeichen} title={'KFZ-Kennzeichen'} />
            <FormColumnContent content={bestellung.spedition} title={'Spediteur'} />
        </FormRow>
    );
};
